<template>
    <div class="chart_warp">
        <div class="own_tool" @click="back">返回主视图</div>
        <div class="chart_cont" ref="graph_chart"></div>
    </div>
</template>

<script>
import { getFormatter, getNodeByEdge, getNodeEdge, deepClone } from '@/api/portrait.js'
import { nodeStyle } from '@/uilt/linkage.js'
// import * as echarts from '@/assets/js/echarts.min.js'

export default {
    props: {
        detailType: String,
        centerId: String,
        nodeNum: String
    },
    data() {
        return {
            myChart: null,
            option: {
                tooltip: {
                    formatter: params => params.nodeName
                },
                series: [
                    {
                        type: 'graph',
                        id: 'graph2',
                        z: 1,
                        center: ['50%', '50%'],
                        label: {
                            show: true,
                            color: '#fff',
                            fontSize: 12,
                        },
                        edgeLabel: {
                            show: false
                        },
                        itemStyle: {
                            borderWidth: 1
                        },
                        lineStyle: {
                            color: '#b2ebf2',
                            opacity: 1,
                            width: 2,
                            curveness: 0 // 连线曲率
                        },
                        emphasis: {
                            focus: 'adjacency',
                            blurScope: 'series',
                            scale: false
                        },
                        blur: {
                            itemStyle: {
                                color: '#f5f5f5',
                                borderColor: '#e6e6e6',
                                opacity: 1
                            },
                            lineStyle: {
                                opacity: 0.1,
                                color: '#e6e6e6'
                            },
                        },
                        layout: 'force',
                        symbol: 'circle',
                        focusNodeAdjacency: true,
                        nodeScaleRatio: 0.1,
                        // draggable: true,
                        roam: true,
                        zoom: 6,
                        scaleLimit: {
                            min: 2,
                            max: 10
                        },
                        force: {
                            gravity: 0.3,
                            repulsion: 40,
                            layoutAnimation: false,
                            friction: 0.1,
                            // edgeLength: [30, 60]
                        },
                        data: [],
                        links: [],
                        animationDuration: 300,
                        animationDurationUpdate: 0
                    }
                ],
                animation: false
            },
            tabsVisible: false,
            tabsNodeIndex: null,
            labelsNodes: [],
            selectIndexs: null,
            isFocus: false,
            roamInfo: null,
            fullscreenLoading: null,
            pieOver: false
        }
    },
    beforeDestroy() {
        this.myChart && this.myChart.clear();
    },
    methods: {
        back() {
            this.$emit('closeOwn')
        },
        openLoading(flag) {
            if (flag) {
                if (!this.fullscreenLoading) {
                    this.fullscreenLoading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        background: 'rgba(0, 0, 0, 0.75)',
                        customClass: 'map_loading',
                        fullscreen: true
                    });
                }
            } else {
                this.fullscreenLoading && this.fullscreenLoading.close()
                this.fullscreenLoading = null
            }
        },
        loadChart(chartId, init = true) {
            if (init) {
                let chartDom = this.$refs[chartId];
                this.myChart = echarts.init(chartDom);
            }

            if (!init) {
                this.myChart.setOption(this.option);
                // 设置高亮点
                let dataIndex = this.selectIndexs ? this.selectIndexs : []
                if (dataIndex.length) {
                    this.myChart.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: dataIndex
                    });
                } else {
                    this.myChart.dispatchAction({
                        type: 'downplay',
                        seriesIndex: 0
                    });
                }
                if (this.isFocus || this.tabsVisible) {
                    this.option.series[0].emphasis.disabled = true
                } else {
                    this.option.series[0].emphasis.disabled = false
                }
                // 设置视图中心点 防止缩放后点击 数据看不见
                this.option.series[0].center = ['50%', '50%']
                if (this.roamInfo) {
                    this.option.series[0].zoom = this.roamInfo.zoom
                    this.option.series[0].center = this.roamInfo.center
                }
            }
            this.myChart.setOption(this.option);

            // 事件监听
            if (init) {
                this.myChart.off('mouseover')
                this.myChart.on('mouseover', (e) => {
                    this.pieOver = true
                    // console.log(e)
                    // e.event.target.cursor = 'pointer'
                })

                this.myChart.off('mouseup')
                this.myChart.on('mouseup', (params) => {
                    // console.log(params)
                    // if (params.componentSubType == "graph" && params.dataType == "edge") {
                    //     var option = this.myChart.getOption();
                    //     option.series[0].data[params.dataIndex].x = params.event.offsetX;
                    //     option.series[0].data[params.dataIndex].y = params.event.offsetY;
                    //     option.series[0].data[params.dataIndex].fixed = true;
                    //     this.myChart.setOption(option);
                    // }
                });

                this.myChart.off('click')
                this.myChart.on('click', (params) => {
                    // this.drag = false
                    // console.log(params)
                    if (!this.isFocus) {
                        if (params.seriesType === "graph") {
                            if (params.dataType === "node") {
                                this.tabsNodeIndex = params.dataIndex
                                this.tabsVisible && this.closeTabs()
                                this.openLoading(true)
                                this.getTabs(params, 'node')
                            }
                        } else if (params.seriesType === "pie") {
                            this.tabsNodeIndex = null
                            this.tabsVisible && this.closeTabs()
                            if (Number(params.data.cnt) > 100) {
                                this.$message('请在详情列表中查看此类数据');
                                return
                            }
                            this.setNodes(params)
                        }
                    }
                });

                this.myChart.off('graphRoam')
                this.myChart.on('graphRoam', (e) => {
                    const zoom = this.myChart._coordSysMgr._coordinateSystems[0]._zoom;
                    const center = this.myChart._coordSysMgr._coordinateSystems[0]._center;
                    this.roamInfo = { center, zoom }

                    if (this.tabsVisible) {
                        this.tabsNodeIndex = null
                        this.closeTabs()
                    }
                })

                this.myChart.off('finished')
                this.myChart.on('finished', (params) => {
                    if (this.tabsVisible && !this.pieOver) {
                        setTimeout(() => {
                            let series = this.getPieSeries()
                            this.myChart.setOption({
                                series: series
                            });
                        }, 100)
                    }
                });

                let Zr = this.myChart.getZr()
                Zr.on('click', (params) => {
                    this.pieOver = false
                    if (this.isFocus) {
                        this.$emit('changeChart', 'deFocus')
                    }
                    // if (this.tabsVisible) {
                    //     this.tabsNodeIndex = null
                    //     this.closeTabs()
                    // }
                })
            }
        },
        // 根据关系图的各节点信息得到饼图数据
        getPieSeries() {
            let chart = this.myChart
            const modal = chart.getModel().getSeriesByIndex(0);
            const info = modal.getData();
            const itemLayouts = info._itemLayouts
            const itemVisuals = info._itemVisuals
            const zoom = chart._coordSysMgr._coordinateSystems[0]._zoom;
            let index = this.tabsNodeIndex, data = this.option.series[0].data[index], series = []
            if (itemLayouts[index]) {
                let x = itemLayouts[index][0]
                let y = itemLayouts[index][1]
                let s = itemVisuals[index].symbolSize
                // convertToPixel()方法的两个参数：第一个参数用来指定坐标系，第二个参数用来指定某个点
                var center = chart.convertToPixel({
                    seriesIndex: 0
                }, [x, y]);
                // 饼图
                let pie = {
                    type: 'pie',
                    name: 'graphPie',
                    id: 'graph2-s_' + index,
                    radius: [s - 8, s + 40],
                    center: center,
                    zlevel: 2,
                    avoidLabelOverlap: false,
                    selectedMode: 'multiple',
                    selectedOffset: 0,
                    showEmptyCircle: false,
                    minAngle: 30,
                    itemStyle: {
                        borderRadius: [0, 10],
                    },
                    label: {
                        position: 'inside',
                        color: '#fff',
                        fontSize: 12,
                        lineHeight: 14,
                        // rotate: true,
                        formatter: (params) => getFormatter(params.name, 4)
                    },
                    data: data.showTab ? data.tabs : [],
                    animationDuration: 100,
                    animationDurationUpdate: 0,
                    animation: false
                }

                if (data.showTab) {
                    series.push(pie)
                }
            }
            return series
        },
        setDataItem(data, opt) {
            let datas = [], dT = this.detailType, _this = this
            // 设置节点数据
            data.map(item => {
                if (!opt || (opt && opt.name != item.name)) {
                    let name = item.nodeName
                    // 计算文字长度 将中文转换为两个字节的英文再计算
                    let len = name.replace(/[\u0391-\uFFE5]/g, 'aa').length
                    // item.fixed = true
                    if (item.isCenter == 1) {
                        item.symbolSize = 80
                        let n = dT == '1' ? 6 : 12
                        item.label = {
                            fontSize: dT == '1' ? 24 : 16,
                            lineHeight: dT == '1' ? 24 : 18,
                            formatter: (params) => {// 设置每6个字符长度换行 中文对应2个字符长度
                                let val = ''
                                if (len > n * 3) {
                                    let nv = name.slice(0, n * 1.5 - 2)
                                    val = `${getFormatter(nv, n)}...`
                                } else {
                                    val = getFormatter(name, n)
                                }
                                return val
                            },
                        }
                        item.itemStyle = {
                            color: '#4162E8',
                            borderColor: "#4162E8",
                            borderWidth: 1,
                        }
                        if (!opt) {
                            this.showEmpty = item.relations.length ? false : true
                            this.centerId = item.properties.id_card
                        }
                    } else {
                        item.label = {
                            fontSize: 14,
                            lineHeight: 16,
                            formatter: getFormatter(name, 6),
                        }
                        const tab = this.currNode.name
                        nodeStyle.map(node => {
                            if (node.tab == tab) {
                                item.type = node.type
                                item.tab = node.tab
                                item.itemStyle = { ...node.itemStyle }
                                item.colors = [node.itemStyle.color, node.itemStyle.borderColor]
                                item.label = {
                                    fontSize: 14,
                                    lineHeight: 16,
                                    color: node.itemStyle.borderColor,
                                    formatter: (params) => {
                                        let val = ''
                                        if (len > node.lineWords * 3) {
                                            let nv = name.slice(0, node.lineWords * 1.5 - 2)
                                            val = `${getFormatter(nv, node.lineWords)}...`
                                        } else {
                                            val = getFormatter(name, node.lineWords)
                                        }
                                        return val
                                    }
                                }
                                // 计算文字行数
                                let rows = Math.ceil(len / node.lineWords)
                                let r = rows > 3 ? 3 : rows
                                let l = (node.lineWords / 2) * 14
                                item.symbolSize = Math.sqrt(Math.pow(0.5 * l + 20, 2) + Math.pow(8 * r, 2))
                                item.emphasis = {
                                    itemStyle: {
                                        color: node.itemStyle.borderColor
                                    },
                                    label: {
                                        color: '#fff'
                                    }
                                }
                                let nodeType = ''
                                if (node.type.indexOf('1-') > -1) {
                                    nodeType = '1'
                                } else if (node.type.indexOf('2-') > -1) {
                                    nodeType = '2'
                                } else if (node.type.indexOf('4-') > -1) {
                                    nodeType = '4'
                                } else if (node.type.indexOf('5-') > -1) {
                                    nodeType = '5'
                                }
                                _this.setLabelsNodes(nodeType, item)
                            }
                        })
                    }

                    let isExist = false, optData = [...this.option.series[0].data]
                    optData.map(dt => {
                        if (dt.name == item.name) {
                            isExist = true
                        }
                    })
                    !isExist && datas.push(item)
                }
            })
            return datas
        },
        setLabelsNodes(type, data) {
            if (this.labelsNodes['data' + type]) {
                let nodeExist = false
                this.labelsNodes['data' + type].map(nd => {
                    if (nd.name == data.name) {
                        nodeExist = true
                    }
                })
                !nodeExist && this.labelsNodes['data' + type].push(data)
            }
        },
        // 关闭tabs
        closeTabs() {
            this.tabsVisible = false
            let datas = this.option.series[0].data, index = this.tabsNodeIndex
            datas = datas.map((item, i) => {
                if (item.tabs && i != index) {
                    item.showTab = false
                }
                return item
            })
            this.option.series[0].data = datas
            this.option.series.splice(1)
            let option = this.myChart.getOption()
            let series = option.series.slice(1)
            series = series.map(s => {
                s.data = []
                return s
            })
            this.myChart.setOption({
                series: series
            })
        },
        setTabs(params, type) {
            if (type == 'node') {
                let nodes = []
                let tabs = params.relations || params
                tabs.map((item, i) => {
                    item.value = 10
                    item.itemStyle = {
                        color: '#B1B1B1'
                    }
                    nodeStyle.map(node => {
                        if (node.tab == item.name) {
                            item.color = node.itemStyle.borderColor
                        }
                    })
                    item.emphasis = {
                        itemStyle: {
                            color: item.color
                        },
                    }
                    item.select = {
                        itemStyle: {
                            color: item.color
                        },
                    }
                    item.tooltip = {
                        formatter: item.name + '-' + item.cnt
                    }
                    nodes.push(item);
                })
                return nodes
            } else {
                let tabs = params
                this.labels = []
                tabs.map(item => {
                    let name = item.name
                    let label = {
                        label: name,
                        icon: 'circle',
                    }
                    nodeStyle.map(node => {
                        if (node.tab == name) {
                            label.itemStyle = node.itemStyle
                        }
                    })
                    this.labels.push(label)
                })
                let lines = [
                    { type: '1', label: '人员关系', icon: 'line', show: true },
                    { type: '2', label: '终端服务', icon: 'line', show: true },
                    { type: '4', label: '终端采购', icon: 'line', show: true },
                    { type: '5', label: '销售流向', icon: 'line', show: true },
                ]
                this.labelIndex = lines.map(line => line.type)
                this.labels = [...this.labels, ...lines]
            }
        },
        getTabs(params, type) {
            let dataIndex = params.dataIndex
            const setSeriesData = (data) => {
                if (data.tabs) {
                    let showTab = this.option.series[0].data[dataIndex].showTab
                    this.option.series[0].data[dataIndex].showTab = !showTab
                    this.tabsVisible = !showTab
                } else {
                    let tabs = this.setTabs(data, type)
                    this.option.series[0].data[dataIndex].tabs = tabs
                    this.option.series[0].data[dataIndex].showTab = true
                    this.tabsVisible = true
                }
                this.currNode = this.option.series[0].data[dataIndex]
                // 更新视图
                this.loadChart('graph_chart', false)
                this.$nextTick(() => {
                    this.openLoading(false)
                })
            }
            if (this.currNode && this.currNode.name == params.data.name) {
                setSeriesData(params.data)
            } else {
                if (params.data.isCenter == 1) {
                    setSeriesData(params.data)
                } else {
                    let param = { idValue: params.data.name, labelName: params.data.labelName }
                    if (this.detailType == '1') {
                        param.centerBizId = this.centerId
                    }
                    getNodeEdge(param).then(res => {
                        let data = res.data
                        setSeriesData(data)
                    })
                }
            }
        },
        getNodes(params, optData, childType) {
            // 设置填充节点
            let optNode = { ...optData }
            if (optNode.isCenter != 1) {
                if (optNode.showChild) {
                    optData.label.color = '#fff'
                    optData.itemStyle.color = optNode.colors[1]
                } else {
                    optData.label.color = optNode.colors[1]
                    optData.itemStyle.color = optNode.colors[0]
                }
            }
            getNodeByEdge(params).then(res => {
                let nodes = res.data.nodes, relationship = res.data.relationship
                let data = [], link = []
                // 设置节点
                if (nodes.length) {
                    data = this.setDataItem(nodes, optData)
                }
                // 设置关系
                if (relationship.length) {
                    relationship.map(item => {
                        // if (item.source == optData.name) {
                        // 1:人员关系 2:终端服务 3:物流配送 4:终端采购 5:销售流向
                        item.label = {
                            color: '#8F8F8F',
                            formatter: item.displayName
                        }
                        item.emphasis = {
                            disabled: true,
                        }
                        let type = item.type
                        if (type == '1') {
                            item.lineStyle = {
                                color: '#1890FF'
                            }
                        } else if (type == '2') {
                            item.lineStyle = {
                                color: '#4FA1A4'
                            }
                        } else if (type == '3') {
                            // item.lineStyle = {
                            //     color: '#1890FF'
                            // }
                        } else if (type == '4') {
                            item.lineStyle = {
                                color: '#ED1651'
                            }
                        } else if (type == '5') {
                            item.lineStyle = {
                                color: '#4DBF22'
                            }
                        }

                        let isExist = false, links = [...this.option.series[0].links]
                        links.map(ln => {
                            if (ln.source == item.source && ln.target == item.target) {
                                isExist = true
                            }
                        })
                        !isExist && link.push(item)

                        // }
                    })
                }

                let dataChildren = [{
                    type: childType,
                    data,
                    link
                }]
                this.$emit('setRestaurants', data)
                if (optData.children) {
                    optData.children.push(...dataChildren)
                } else {
                    optData.children = dataChildren
                }
                this.option.series[0].data.push(...data)
                this.option.series[0].links.push(...link)
                // 更新视图
                this.loadChart('graph_chart', false)
                this.$nextTick(() => {
                    this.openLoading(false)
                })
            })
        },
        setNodes(params) {
            this.currNode = params
            let dataIndex = Number(params.seriesId.split('_')[1])
            let seriesIndex = params.seriesIndex
            let options = this.myChart.getOption()
            let selectedMap = options.series[seriesIndex].selectedMap
            let optData = this.option.series[0].data[dataIndex]
            let childType = ''
            nodeStyle.map(node => {
                if (node.tab == params.name) {
                    childType = node.type
                }
            })
            // 判断节点数量
            let ownOption = null
            if (Number(params.data.cnt) > Number(this.nodeNum)) {
                if (selectedMap[params.name]) {
                    optData.showChild = true
                    this.$emit('setResultsList', [optData])
                }
                let option = this.myChart.getOption()
                option.series[0].data = [optData]
                option.series[0].links = []
                option.series.splice(1)
                ownOption = option
                this.option = { ...option }
            }

            let children = optData.children ? optData.children : null
            if (children) {
                let childNodes = children.filter(item => item.type == childType)
                if (childNodes.length) { // 节点数据已存在
                    let nodeData = childNodes[0].data.filter(cd => cd.showChild)
                    if (nodeData.length && !selectedMap[params.name]) return
                    let datas = this.arrReduceDelete(childNodes[0].data, this.option.series[0].data)
                    let links = this.arrReduceDelete(childNodes[0].link, this.option.series[0].links)
                    this.option.series[0].data = datas
                    this.option.series[0].links = links
                    this.$emit('setRestaurants', childNodes[0].data, 'delete')
                    if (ownOption == null || dataIndex == 0) {
                        if (selectedMap[params.name]) {
                            this.openLoading(true)
                            optData.showChild = true
                            this.option.series[0].data.push(...childNodes[0].data)
                            this.option.series[0].links.push(...childNodes[0].link)
                            this.$emit('setRestaurants', childNodes[0].data)
                        } else {
                            let isShow = false
                            for (var s in selectedMap) {
                                if (selectedMap[s]) {
                                    isShow = true
                                }
                            }
                            if (!isShow) {
                                optData.showChild = false
                            }
                        }
                    }
                    // 设置填充节点
                    let optNode = { ...optData }
                    if (optNode.isCenter != 1) {
                        if (optNode.showChild) {
                            optData.label.color = '#fff'
                            optData.itemStyle.color = optNode.colors[1]
                        } else {
                            optData.label.color = optNode.colors[1]
                            optData.itemStyle.color = optNode.colors[0]
                        }
                    }
                    // 更新视图
                    this.loadChart('graph_chart', false)
                    this.$nextTick(() => {
                        this.openLoading(false)
                    })
                } else { // 节点数据不存在
                    if (selectedMap[params.name]) {
                        this.openLoading(true)
                        optData.showChild = true
                        let param = { idValue: optData.name, labelName: optData.labelName, edgeName: params.data.relation }
                        if (this.detailType == '1') {
                            param.centerBizId = this.centerId
                        }
                        this.getNodes(param, optData, childType)
                    }
                }
            } else {
                if (selectedMap[params.name]) {
                    this.openLoading(true)
                    optData.showChild = true
                    let param = { idValue: optData.name, labelName: optData.labelName, edgeName: params.data.relation }
                    if (this.detailType == '1') {
                        param.centerBizId = this.centerId
                    }
                    this.getNodes(param, optData, childType)
                }
            }
        },
        // 数组 reduce 删除
        arrReduceDelete(originArr, targetArr) {
            let data = originArr.reduce((acc, cur) => {
                let index = null
                let target = acc.find((e, i) => {
                    if (JSON.stringify(e) == JSON.stringify(cur)) {
                        index = i
                        return true
                    } else {
                        return false
                    }
                })
                if (target) {
                    acc.splice(index, 1)
                }
                return acc
            }, targetArr)
            return data
        },
    }
}
</script>

<style lang="less" scoped>
.chart_warp {
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: relative;

    .chart_cont {
        width: 100%;
        height: 100%;
    }

    .own_tool {
        position: absolute;
        top: 4px;
        left: 4px;
        padding: 8px;
        background: #ddd;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 12px;
        color: #212121;
        cursor: pointer;
        z-index: 2;

        &:hover {
            background-color: #4FA1A4;
            border-color: #4FA1A4;
            color: #fff;
        }
    }
}
</style>
